import React from 'react';
import { CommandMenu } from '@milanote/roma';
import { GridListHeader, GridListSection as AriaGridListSection, Key } from 'react-aria-components';

import LabelListElement from './LabelListElement';
import { Label } from '../../../../../../../common/labels/labelTypes';

type Props = {
    checkedLabelIds: Set<Key>;
    editingLabelId: string | null;
    header?: string;
    labels: Label[];
    onEditingChange: (labelId: string, nextIsEditing: boolean) => void;
    sectionClassName?: string;
    sectionId?: string;
    showSeparator?: boolean;
};

const LabelListSection: React.FC<Props> = ({
    checkedLabelIds,
    editingLabelId,
    header,
    labels,
    onEditingChange,
    sectionClassName,
    sectionId,
    showSeparator = false,
}) => {
    if (!labels.length) return null;

    const content = (
        <>
            {(header || showSeparator) && (
                <GridListHeader>
                    {showSeparator && <CommandMenu.Base.Separator />}
                    {header && <CommandMenu.Base.Header className="px-4">{header}</CommandMenu.Base.Header>}
                </GridListHeader>
            )}
            {labels.map((label) => (
                <LabelListElement
                    key={label._id}
                    label={label}
                    onEditingChange={onEditingChange}
                    isSelected={checkedLabelIds.has(label._id)}
                    isEditing={editingLabelId === label._id}
                />
            ))}
        </>
    );

    if (!sectionId) return content;

    return (
        <AriaGridListSection id={sectionId} className={sectionClassName}>
            {content}
        </AriaGridListSection>
    );
};

export default LabelListSection;
